module.exports = "/_next/static/images/solutionsImage-2x-40dda547f8094b351e41911dfd7ebf88.jpg.webp";